// Base nativa local de CEPs reais (gerados via seed script, populados estaticamente)
// Estrutura por UF: [{ cep, logradouro, bairro, cidade, estado }, ...]

import al from '../data/ceps/al.json';
import ba from '../data/ceps/ba.json';
import ce from '../data/ceps/ce.json';
import df from '../data/ceps/df.json';
import es from '../data/ceps/es.json';
import mg from '../data/ceps/mg.json';
import ms from '../data/ceps/ms.json';
import pb from '../data/ceps/pb.json';
import pe from '../data/ceps/pe.json';
import pi from '../data/ceps/pi.json';
import pr from '../data/ceps/pr.json';
import rn from '../data/ceps/rn.json';
import rs from '../data/ceps/rs.json';
import sc from '../data/ceps/sc.json';
import se from '../data/ceps/se.json';

export const cepsByState = {
  AL: al, BA: ba, CE: ce, DF: df, ES: es,
  MG: mg, MS: ms, PB: pb, PE: pe, PI: pi,
  PR: pr, RN: rn, RS: rs, SC: sc, SE: se,
};

// Histórico recente para reduzir repetição visual entre gerações consecutivas
const recentByState = {};
const HISTORY_SIZE = 25;

/**
 * Pega um CEP aleatório da base local, evitando repetir os últimos N usados.
 * Se `cityName` for fornecido, filtra apenas CEPs daquela cidade.
 * Retorna null se o estado/cidade não tiver base.
 */
export function pickRandomLocalCep(uf, cityName = null) {
  const list = cepsByState[uf];
  if (!list || list.length === 0) return null;

  // Filtra por cidade quando especificada (case-insensitive)
  let scoped = list;
  if (cityName && cityName !== 'random') {
    const target = cityName.toLowerCase();
    scoped = list.filter((c) => c.cidade && c.cidade.toLowerCase() === target);
    if (scoped.length === 0) return null;
  }

  const recent = recentByState[uf] || [];
  const available = scoped.length > recent.length
    ? scoped.filter((c) => !recent.includes(c.cep))
    : scoped;
  const pool = available.length > 0 ? available : scoped;

  const item = pool[Math.floor(Math.random() * pool.length)];

  // Atualiza histórico
  const updated = [...recent, item.cep];
  if (updated.length > HISTORY_SIZE) updated.shift();
  recentByState[uf] = updated;

  return item;
}

/** Total de CEPs disponíveis na base local (debug/stats). */
export function getLocalBaseStats() {
  const stats = {};
  let total = 0;
  for (const uf of Object.keys(cepsByState)) {
    stats[uf] = cepsByState[uf].length;
    total += cepsByState[uf].length;
  }
  return { total, byState: stats };
}

// Cache de cidades disponíveis por UF (computado uma vez)
const citiesSetByState = {};
for (const uf of Object.keys(cepsByState)) {
  citiesSetByState[uf] = new Set(cepsByState[uf].map((c) => c.cidade));
}

/** Retorna um Set com nomes de cidades que possuem CEPs na base para a UF. */
export function citiesAvailableForState(uf) {
  return citiesSetByState[uf] || new Set();
}
